'use strict';

require('views/Signin/Signin.scss');

const React = require('react/addons'),
    mui = require('material-ui'),
    {TextField, RaisedButton} = mui,
    security = require('services/Security'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    DashboardStore = require('stores/DashboardStore'),
    ContentUtils = require('utils/ContentUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    NumberUtils = require('utils/NumberUtils'),
    auth = security.auth,
    {toLower} = require('lodash/string'),
    SessionActionCreators = require('actions/SessionActionCreators'),
    ga = require('react-ga'),
    {categories, actions} = require('constants/AppConstants').Analytics,
    Router = require('react-router'),
    {Link} = Router;



const Login = React.createClass({displayName: "Login",

    mixins:[Router.Navigation],

    contextTypes: {
        router: React.PropTypes.func
    },

    getInitialState() {
        this.MESSAGE_ERRORS = {
            applicant_blocked: 'sign_in_user_blocked'
        };
        return {
            error: false
        };
    },

    componentDidMount() {
        DashboardStore.setIsFetchingDashboardContent(false);
        const messageErrorCode = NavigationUtils.getQueryParam('message');
        if (messageErrorCode) {
            this.setState({error:messageErrorCode });
        }
    },

    handleSubmit(texts, event) {
        DashboardStore.setIsFetchingDashboardContent(false);
        event.preventDefault();
        const username = toLower(this.refs.username.getValue());
        const pass = this.refs.pass.getValue();
        auth.login(username, pass, texts, this._onSuccess, this._onFailure);
    },

    _onSuccess(userName, token, applicantId, texts) {
        DashboardStore.setIsFetchingDashboardContent(false);
        this.transitionTo('/dashboard');
        SessionActionCreators.loggedIn(userName, token, applicantId, texts);
        SessionActionCreators.permissionRequestUpdate(userName, token, applicantId);
        SessionStore.fetchUserInformationAndSaveIfNeeded(() => {
            NumberUtils.initializeFormat();
        });
        ga.event({
            category: categories.APPLICATION,
            action: actions.SIGN_IN,
            label: t('signin_applicant') + SessionStore.getCurrentApplicant() + t('history_modal_description_user') + ContentUtils.getSession('userNameSession')
        });
    },

    _onFailure() {
        this.setState({
            error:  t('sign_in_error_inline')
        });
    },

    render() {

        const errorText = t(this.MESSAGE_ERRORS[this.state.error || '']);
        const isApplicantBlocked = this.state.error === 'applicant_blocked';

        let loginContentClassName = 'box-content login-content';

        if (!SessionStore.isFullPaidVersion()) {
            loginContentClassName += ' is-free-version';
        }
        
        const texts = {
            confirmationAccept: t('confirmation_accept_brewplanner_updated'),
            labelPrivacy: t('label_privacy_policy'),
            labelAnd: t('label_and'),
            labelUserAgreement: t('label_user_agreement')
        };

        const handlerSubmit = this.handleSubmit.bind(this, texts);
        
        return (
            React.createElement("div", {id: "page-login", className: "row"}, 
                React.createElement("div", {className: "text-center bp-login-view"}, 
                    React.createElement("form", {onSubmit: handlerSubmit, className: "box"}, 
                        React.createElement("div", {className: loginContentClassName}, 
                            React.createElement("img", {idth: "150", height: "60", src: "/assets/images/logo-small.png"}), 
                            React.createElement("div", {className: "text-center"}, 

                            isApplicantBlocked && (
                                React.createElement("div", {style: { border: '1px solid red', borderRadius: 20, padding: 20, backgroundColor: 'red', color: 'white'}}, 
                                    React.createElement("div", null, "Your trial version or subscription has ended..."), 
                                    React.createElement("br", null), 
                                    React.createElement("a", {target: "_blank", href: "https://www.brewplanner.com/payment"}, React.createElement(RaisedButton, {className: "BPButton", secondary: true, label: "Upgrade"}))
                                )
                            ), 

                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    className: "full-width id-username", 
                                    ref: "username", 
                                    hintText: t('sign_in_placeholder_username'), 
                                    defaultValue: "", 
                                    floatingLabelText: t('sign_in_label_username'), 
                                    onEnterKeyDown: handlerSubmit, 
                                    errorText:  this.state.error ? 'Login failed' : ''}
                                )
                            ), 
                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    type: "password", 
                                    className: "full-width id-password", 
                                    ref: "pass", 
                                    hintText: t('sign_in_placeholder_password'), 
                                    defaultValue: "", 
                                    floatingLabelText: t('sign_in_label_password'), 
                                    onEnterKeyDown: handlerSubmit, 
                                    errorText: errorText }
                                )
                            ), 
                                React.createElement(RaisedButton, {className: "BPButton", label: "Sign in", secondary: true, onClick: handlerSubmit}), 
                                React.createElement("div", {className: "text-center"}, 
                                    React.createElement("br", null), 
                                    React.createElement(Link, {to: "signUp", className: "txt-default"}, t('sign_in_label_need_account')), 
                                    " | ", 
                                    React.createElement("span", {className: "text-right"}, 
                                    React.createElement(Link, {to: "passwordRecovery", className: "txt-default"}, t('sign_in_label_forgot_password'))
                                    )
                                )
                            
                            )
                        )
                    )
                )
            )
        );
    }
});

module.exports = Login;



/** WEBPACK FOOTER **
 ** ./src/views/Signin/Signin.jsx
 **/